// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2q1JM","requiredAsterisk":"Info_requiredAsterisk__2AVwF"};